<template>
  <vx-card>
    <vs-row>
      <h4 class="mb-5">Edit Fleet Type</h4>
    </vs-row>

    <vs-row v-if="!loading" vs-w="12">
      <vs-col vs-w="12">
        <vs-row vs-w="12">
          <vs-col vs-w="12" class="mb-3">
            <vs-input class="w-full" label="Name (*)" v-model="payload.name" />
            <span class="block text-sm mt-2 text-danger">{{
              errors.first("name")
            }}</span>
          </vs-col>

          <vs-col vs-w="12" class="mt-3">
            <div class="vx-col w-full" @click.prevent="storeData">
              <vs-button class="mr-3 mb-2">Submit</vs-button>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
// Store Module

import identificationTypeStore from "@/store/identification-type";
import vSelect from "vue-select";
import StarRating from "vue-star-rating";

export default {
  name: "IdentificationTypeEdit",

  metaInfo: {
    title: "Edit Identification Type",
    titleTemplate: "%s - Vancy Net",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  components: {
    vSelect,
    StarRating,
  },

  computed: {
    decryptedID() {
      return this.$secure.decrypt(this.$route.params.id);
    },
    brands() {
      return this.$store.state.brandManagement.brands;
    },
  },

  data: () => ({
    loading: true,
    payload: {
      name: "",
    },
  }),

  methods: {
    async getData() {
      this.$vs.loading();

      const response = await this.$store.dispatch(
        "identificationType/fetchIdentificationType",
        this.decryptedID
      );
      this.payload.name = response.message.name;
      this.loading = false;
      this.$vs.loading.close();
    },

    async storeData() {
      const formData = new FormData();
      // set formData
      formData.set("name", this.payload.name);
      formData.append("_method", "PUT");
      const response = await this.$store.dispatch(
        "identificationType/updateIdentificationType",
        {
          id: this.decryptedID,
          body: formData,
        }
      );
      if (!response.success) {
        this.$catchErrorResponse(response.message);
        return;
      }

      this.$vs.notify({
        title: "Successful",
        text: response.msg_status,
        iconPack: "feather",
        icon: "icon-check-circle",
        color: "success",
      });

      this.$router.push("/identification-type");
    },
  },

  created() {
    if (!identificationTypeStore.isRegistered) {
      this.$store.registerModule("identificationType", identificationTypeStore);
      identificationTypeStore.isRegistered = true;
    }
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<style></style>
